import { Box, Button, Paper } from "@mui/material";
import { useMsal } from "@azure/msal-react";

const LoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect({
      scopes: window.ENVIRONMENT.azureAdCredentials.scopes,
      redirectUri: window.ENVIRONMENT.azureAdCredentials.redirectUri,
    },);
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: 'url("/assets/login-background.svg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          padding: 4,
          height: 229,
          width: 368,
          gap: 7,
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // horizontally center items
          justifyContent: "center",
        }}
      >
        <img
          src="/assets/logo-login.svg"
          alt="Logo"
          style={{ width: "auto", height: 36, marginBottom: 30 }}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleLogin}
        >
          Sign in using SSO
        </Button>
      </Paper>
    </Box>
  );
};

export default LoginPage;
